import * as actions from '../../actions/reports/inventoryActions'

export const initialState = {
    inventory: [],
    loading: false,
    hasErrors: false,
}

export default function inventoryReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_INVENTORY:
            return { ...state, loading: true }
        case actions.GET_INVENTORY_SUCCESS:
            return { inventory: action.payload, loading: false, hasErrors: false }
        case actions.GET_INVENTORY_FAILURE:
            return { ...state, loading: false, hasErrors: true }
        default:
            return state
    }
}